import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { AppsAPI } from "src/api";
import NewVersion from "src/components/screens/Mobile/NewVersion";
import List from "src/components/screens/Mobile/ReleaseList";
import { Loading, Screen } from "src/components/structure";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Card } from "src/components/structure";

interface IFirmwareReleasesProps {
  userState: any;
}

interface IFirmwareReleasesState {
  loading: boolean;
  fwosVersions: any[];
}
class FirmwareReleases extends Component<
  IFirmwareReleasesProps,
  IFirmwareReleasesState
> {
  constructor(props: IFirmwareReleasesProps) {
    super(props);

    this.state = {
      loading: false,
      fwosVersions: [],
    };

    this.updateField = this.updateField.bind(this);
    this.getVersions = this.getVersions.bind(this);
    this.handleNewVersionCreated = this.handleNewVersionCreated.bind(this);
  }

  componentDidMount() {
    this.getVersions();
  }
 
  updateField(e: any) {
    let ns: any = this.state;
    ns[e.target.id] = e.target.value;
    this.setState(ns);
  }

  private handleNewVersionCreated() {
    this.getVersions();
  }

  private getVersions() {
    this.setState({ loading: true }, async () => {
      try {
        const fwosVersions = await AppsAPI.getAppVersionForOS("wagz", "fwos");
        this.setState({ loading: false, fwosVersions });
      } catch (err) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    return (
      <Screen id="firmware_releases" requiredRoles={["firmware"]}>
        <div className="row">
          <div className="col-sm-12 col-lg-7">
            <Card title="Release Versions">
              <Tabs>
                <TabList>
                  <Tab>FWOS</Tab>
                </TabList>
                <TabPanel>
                  {this.state.loading ? (
                    <Loading />
                  ) : (
                    <List
                      versions={this.state.fwosVersions}
                      loading={this.state.loading}
                      onVersionsCreated={this.handleNewVersionCreated}
                    />
                  )}
                </TabPanel>
              </Tabs>
            </Card>
          </div>
          <div className="col-sm-12 col-lg-5">
            <NewVersion
              loading={this.state.loading}
              onVersionsCreated={this.handleNewVersionCreated}
            />
          </div>
        </div>
      </Screen>
    );
  }
}

const mapStateToProps = function map(s: any) {
  return {
    userState: s.userState,
  };
};

function mapDispatchToProps() {
  return {};
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FirmwareReleases) as any
);
